module.exports = __webpack_public_path__ + "static/img/pic3.d32924a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic3.png
// module id = fb1i
// module chunks = 1